import React, { useEffect, useState, useRef } from "react";
import { FaLock, FaLockOpen, FaSyncAlt, FaPlus, FaMinus, FaUndo, FaDoorOpen, FaMoneyCheckAlt  } from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import { formatCurrency, getCashStatus, sqlDateFormat } from "../../../utils/Common";
import { BsGrid3X3GapFill, BsList } from 'react-icons/bs';
import Spinner from "../../Spinner";
import { Button } from "react-bootstrap";
import "./index.css"; 

const CajaCard = ({ 
    caja, 
    isLoading, 
    rotate,
    handleCashTransaction, 
    handleOpenCloseCash, 
    handleReloadCashStatus, 
    handleNewBalanceChange,
    newBalance,
    showAddWithdrawButtons, 
    roleBli,
    hasPendingRequest,
    viewType = "line" // "line", "grid", "table"
    }) => {
    const [isRotating, setIsRotating] = useState(false);
    const [isLoadingAdd, setIsLoadingAdd] = useState(false);
    const [isLoadingWithdraw, setIsLoadingWithdraw] = useState(false);
    const [isLoadingCancel, setIsLoadingCancel] = useState(false);
    const [open, setOpen] = useState(false);
    const [montoAnulado, setMontoAnulado] = useState(0);

    // Función para obtener el estado del indicador de actividad
    const getActivityStatus = (isActive) => {
        return {
            isActive: isActive === 1,
            color: isActive === 1 ? '#28a745' : '#dc3545',
            text: isActive === 1 ? 'Activa' : 'Inactiva'
        };
    };

    const handleReloadClick = async (cashId) => {
        setIsRotating(true);
        await handleReloadCashStatus(cashId);
        setIsRotating(false);
    };

    const handleTransaction = async (cash, amount, type) => {
      if (type === 3) setIsLoadingAdd(true);
      if (type === 4) setIsLoadingWithdraw(true);
      if (type === 5) setIsLoadingCancel(true);
    
      await handleCashTransaction(cash, amount, type);
    
      if (type === 3) setIsLoadingAdd(false);
      if (type === 4) setIsLoadingWithdraw(false);
      if (type === 5) setIsLoadingCancel(false);
    };

    useEffect(() => {
        if (caja.IdTipoMovimiento === 3) {
            setMontoAnulado(caja.MontoMovimiento);
        }
    }, [caja.IdTipoMovimiento, caja.MontoMovimiento]);

    if (viewType === "table") {
        const activityStatus = getActivityStatus(caja.IsActive);
        return (
            <div className="caja-table-row">
                <div className="caja-table-cell">
                    <div className="d-flex align-items-center">
                        <div
                            style={{
                                color: "white",
                                background: getCashStatus(caja.EstatusCaja)?.color,
                                padding: "0.25rem 0.5rem",
                                fontWeight: "bold",
                                borderRadius: "0.5rem",
                                cursor: roleBli >= 2 ? "pointer" : "default",
                                fontSize: "0.8rem",
                                marginRight: "0.5rem"
                            }}
                            onClick={roleBli >= 2 ? () => handleOpenCloseCash(caja.EstatusCaja === 1 ? 2 : 1, caja) : null}
                        >
                            {isLoading[caja.IdCaja] && !rotate ? (
                                <Spinner type={1} style={{ width: '12px', height: '12px' }} />  
                            ) : (
                                <>
                                    {getCashStatus(caja.EstatusCaja)?.icon}{" "}
                                    {getCashStatus(caja.EstatusCaja)?.text}
                                </>
                            )}
                        </div>
                        <div
                            className="activity-indicator"
                            style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: activityStatus.color,
                                marginRight: '8px',
                                flexShrink: 0
                            }}
                            title={activityStatus.text}
                        />
                        <FaSyncAlt
                            size={14}
                            style={{ cursor: "pointer", animation: isRotating ? "spin 2s linear infinite" : "none" }}
                            onClick={() => handleReloadClick(caja.IdCaja)}
                        />
                    </div>
                </div>
                <div className="caja-table-cell">
                    <div>{caja?.NombreSucursal}</div>
                </div>
                <div className="caja-table-cell">{caja?.NombreCaja}</div>
                <div className="caja-table-cell">{formatCurrency(caja?.SaldoCaja || 0)}</div>
                <div className="caja-table-cell">
                    {showAddWithdrawButtons ? (
                        <div className="d-flex">
                            <input
                                type="number"
                                className="form-control form-control-sm mr-2"
                                style={{ width: "80px" }}
                                onChange={(e) => handleNewBalanceChange(e, caja.IdCaja)}
                                name="monto"
                                step="any"
                                placeholder="Monto"
                                value={newBalance[caja.IdCaja] || ""}
                                disabled={caja.EstatusCaja === 1}
                            />
                            {isLoadingAdd ? (
                                <button className="btn btn-sm btn-blue mr-2" disabled>
                                    <Spinner type={1} size={10} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-sm btn-blue mr-2"
                                    onClick={() => handleTransaction(caja, newBalance[caja.IdCaja], 3)}
                                    disabled={caja.EstatusCaja === 1 || !newBalance[caja.IdCaja] || isNaN(Number(newBalance[caja.IdCaja])) || hasPendingRequest}
                                >
                                    +
                                </button>
                            )}
                            {isLoadingWithdraw ? (
                                <button className="btn btn-sm btn-outline-blue mr-2" disabled>
                                    <Spinner type={1} size={10} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-sm btn-outline-blue mr-2"
                                    onClick={() => handleTransaction(caja, newBalance[caja.IdCaja], 4)}
                                    disabled={caja.EstatusCaja === 1 || !newBalance[caja.IdCaja] || isNaN(Number(newBalance[caja.IdCaja])) || hasPendingRequest}
                                >
                                    -
                                </button>
                            )}
                            {[3].includes(caja.IdTipoMovimiento) && caja.SaldoCaja === caja.UltimoSaldoAgregado && (
                                isLoadingCancel ? (
                                    <button className="btn btn-sm btn-warning mr-2" disabled>
                                        <Spinner type={1} size={10} />
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-sm btn-warning mr-2"
                                        onClick={() => handleTransaction(caja, montoAnulado, 5)}
                                        disabled={caja.EstatusCaja === 1 || !montoAnulado || isNaN(Number(montoAnulado)) || hasPendingRequest}
                                    >
                                        ↺
                                    </button>
                                )
                            )}
                        </div>
                    ) : (
                        <button
                            className="btn btn-sm btn-blue"
                            onClick={() => handleOpenCloseCash(caja.EstatusCaja === 1 ? 2 : 1, caja)}
                            disabled={!caja || isLoading[caja.IdCaja]}
                        >
                            {isLoading[caja.IdCaja] ? (
                                <Spinner type={1} style={{ width: '12px', height: '12px' }} />  
                            ) : (
                                <>
                                    <FaLock size={10} /> Confirmar
                                </>
                            )}
                        </button>
                    )}
                </div>
            </div>
        );
    }

    if (viewType === "grid") {
        const activityStatus = getActivityStatus(caja.IsActive);
        return (
            <div className="caja-grid-card">
                    <div className="caja-grid-header">
                    <div className="d-flex align-items-center">
                        <div
                            style={{
                                color: "white",
                                background: getCashStatus(caja.EstatusCaja)?.color,
                                padding: "0.25rem 0.5rem",
                                fontWeight: "bold",
                                borderRadius: "0.5rem",
                                cursor: roleBli >= 2 ? "pointer" : "default",
                                fontSize: "0.7rem",
                                textAlign: "center"
                            }}
                            onClick={roleBli >= 2 ? () => handleOpenCloseCash(caja.EstatusCaja === 1 ? 2 : 1, caja) : null}
                        >
                            {isLoading[caja.IdCaja] && !rotate ? (
                                <Spinner type={1} style={{ width: '12px', height: '12px' }} />  
                            ) : (
                                <>
                                    {getCashStatus(caja.EstatusCaja)?.icon}{" "}
                                    {getCashStatus(caja.EstatusCaja)?.text}
                                </>
                            )}
                        </div>
                        <div
                            className="activity-indicator"
                            style={{
                                width: '8px',
                                height: '8px',
                                borderRadius: '50%',
                                backgroundColor: activityStatus.color,
                                marginRight: '8px',
                                flexShrink: 0
                            }}
                            title={activityStatus.text}
                        />
                        <FaSyncAlt
                            size={14}
                            style={{ cursor: "pointer", animation: isRotating ? "spin 2s linear infinite" : "none" }}
                            onClick={() => handleReloadClick(caja.IdCaja)}
                        />
                    </div>
                </div>
                
                <div className="caja-grid-info">
                    <div className="caja-grid-field">
                        <label>Estafeta:</label>
                        <span>{caja?.NombreSucursal}</span>
                    </div>
                    <div className="caja-grid-field">
                        <label>Caja:</label>
                        <span>{caja?.NombreCaja}</span>
                    </div>
                    <div className="caja-grid-field">
                        <label>Saldo:</label>
                        <span className="caja-grid-saldo">{formatCurrency(caja?.SaldoCaja || 0)}</span>
                    </div>
                    {hasPendingRequest && (
                    <div className="alert alert-warning text-center" role="alert" style={{ marginBottom: "1rem" }}>
                    La última solicitud está en proceso. Por favor, espera a que sea aceptada, rechazada o cancelada.
                    </div>
                )}
                </div>

                {showAddWithdrawButtons ? (
                    <div className="caja-grid-actions">
                        <input
                            type="number"
                            className="form-control form-control-sm mb-2"
                            onChange={(e) => handleNewBalanceChange(e, caja.IdCaja)}
                            name="monto"
                            step="any"
                            placeholder="Monto"
                            value={newBalance[caja.IdCaja] || ""}
                            disabled={caja.EstatusCaja === 1}
                        />
                        <div className="caja-grid-buttons">
                            {isLoadingAdd ? (
                                <button className="btn btn-sm btn-blue" disabled>
                                    <Spinner type={1} size={10} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-sm btn-blue"
                                    onClick={() => handleTransaction(caja, newBalance[caja.IdCaja], 3)}
                                    disabled={caja.EstatusCaja === 1 || !newBalance[caja.IdCaja] || isNaN(Number(newBalance[caja.IdCaja])) || hasPendingRequest}
                                >
                                    +
                                </button>
                            )}
                            {isLoadingWithdraw ? (
                                <button className="btn btn-sm btn-outline-blue" disabled>
                                    <Spinner type={1} size={10} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-sm btn-outline-blue"
                                    onClick={() => handleTransaction(caja, newBalance[caja.IdCaja], 4)}
                                    disabled={caja.EstatusCaja === 1 || !newBalance[caja.IdCaja] || isNaN(Number(newBalance[caja.IdCaja])) || hasPendingRequest}
                                >
                                    -
                                </button>
                            )}
                            {[3].includes(caja.IdTipoMovimiento) && caja.SaldoCaja === caja.UltimoSaldoAgregado && (
                                isLoadingCancel ? (
                                    <button className="btn btn-sm btn-warning" disabled>
                                        <Spinner type={1} size={10} />
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-sm btn-warning"
                                        onClick={() => handleTransaction(caja, montoAnulado, 5)}
                                        disabled={caja.EstatusCaja === 1 || !montoAnulado || isNaN(Number(montoAnulado)) || hasPendingRequest}
                                    >
                                        ↺
                                    </button>
                                )
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="caja-grid-actions">
                        <button
                            className="btn btn-sm btn-blue w-100"
                            onClick={() => handleOpenCloseCash(caja.EstatusCaja === 1 ? 2 : 1, caja)}
                            disabled={!caja || isLoading[caja.IdCaja]}
                        >
                            {isLoading[caja.IdCaja] ? (
                                <Spinner type={1} style={{ width: '12px', height: '12px' }} />  
                            ) : (
                                <>
                                    <FaLock size={10} /> Confirmar
                                </>
                            )}
                        </button>
                    </div>
                )}
            </div>
        );
    }

    // Vista línea (por defecto)
    const activityStatus = getActivityStatus(caja.IsActive);
    return (
            <div className="dashboardCard text-left" style={{ color: "black", marginBottom: "20px" }}>
            <div className="d-flex align-content-center justify-content-between">
                <div className="d-flex align-items-center">
                    <div
                        style={{
                            color: "white",
                            background: getCashStatus(caja.EstatusCaja)?.color,
                            padding: "0.5rem 1rem",
                            fontWeight: "bold",
                            borderRadius: "1rem",
                            cursor: roleBli >= 2 ? "pointer" : "default",
                            width: "150px", 
                            textAlign: "center" 
                        }}
                        onClick={roleBli >= 2 ? () => handleOpenCloseCash(caja.EstatusCaja === 1 ? 2 : 1, caja) : null}
                    >
                        <span>
                            {isLoading[caja.IdCaja] && !rotate ? (
                                <Spinner type={1} style={{ width: '20px', height: '20px' }} />  
                            ) : (
                                <>
                                    {getCashStatus(caja.EstatusCaja)?.icon}{" "}
                                    {getCashStatus(caja.EstatusCaja)?.text}
                                </>
                            )}
                        </span>
                    </div>
                    <div
                        className="activity-indicator"
                        style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: activityStatus.color,
                            marginLeft: '10px',
                            flexShrink: 0
                        }}
                        title={activityStatus.text}
                    />
                </div>
            
                    <FaSyncAlt
                        size={20}
                        style={{ cursor: "pointer", animation: isRotating ? "spin 2s linear infinite" : "none" }}
                        onClick={() => handleReloadClick(caja.IdCaja)}
                    />
                
            </div>
            <div className="d-flex align-items-center mt-3" style={{ gap: 20 }}>
                <div className="form-group">
                    <label>Estafeta</label>
                    <input type="text" className="form-control" value={caja?.NombreSucursal} readOnly />
                </div>
                <div className="form-group">
                    <label>Caja</label>
                    <input type="text" className="form-control" value={`#${caja?.IdCaja ?? ""} - ${caja?.NombreCaja ?? ""}`} readOnly
                    />
                </div>
            </div>

            <div className="text-left caja-movimientos">
            <div className="d-flex align-items-center">
              <BsClockHistory size={16} />
                <Button
                  onClick={() => setOpen(!open)}
                  aria-expanded={open}
                  variant="link"
                  className="toggle-button no-outline ml-2"
                >
                  {open ? "Ocultar movimientos" : "Mostrar movimientos"}
                </Button>
            </div>

            <div className={`movimientos-info ${open ? "show" : "hide"}`}>
                <div className="mt-2">
                    <div className="card-body p-1">
                    {caja.EstatusCaja === 1 ? (
                        <>
                        <FaDoorOpen style={{ color: 'blue', marginRight: '5px' }} />
                        Última apertura:{" "}
                        </>
                    ) : (
                        <>
                        <FaLockOpen style={{ color: 'blue', marginRight: '5px' }} />
                        Último cierre:{" "}
                        </>
                    )}
                    <span className="info-text">
                        {caja?.FechaMovimientoCajero
                            ? sqlDateFormat(caja.FechaMovimientoCajero, false, true)
                            : "Sin apertura/cierre registrado aún"}
                    </span>
                    </div>
                </div>
                {roleBli >= 2 && (
                    <>
                    <div className="mt-2">
                        <div className="card-body p-1">
                        <FaMoneyCheckAlt style={{ color: 'green', marginRight: '5px' }} />
                        Último saldo de apertura:{" "}
                        <span className="info-text">
                            {formatCurrency(caja?.UltimoSaldoApertura ?? 0)}
                        </span>
                        </div>
                    </div>
                    
                    <div className="mt-2">
                        <div className="card-body p-1">
                        <FaMoneyCheckAlt style={{ color: 'red', marginRight: '5px' }} />
                        Último saldo de cierre:{" "}
                        <span className="info-text">
                            {formatCurrency(caja?.UltimoSaldoCierre ?? 0)}
                        </span>
                        </div>
                    </div>
                    {[3, 4, 5].includes(caja.IdTipoMovimiento) && (
                        <div className="mt-2">
                        <div className="card-body p-1">
                            {caja.IdTipoMovimiento === 3 ? (
                            <>
                                <FaPlus style={{ color: 'green', marginRight: '5px' }} />
                                Último monto añadido:{" "}
                            </>
                            ) : caja.IdTipoMovimiento === 4 ? (
                            <>
                                <FaMinus style={{ color: 'red', marginRight: '5px' }} />
                                Último monto retirado:{" "}
                            </>
                            ) : (
                            <>
                                <FaUndo style={{ color: 'orange', marginRight: '5px' }} />
                                Último monto anulado:{" "}
                            </>
                            )}
                            <span className="info-text">
                            {formatCurrency(caja.MontoMovimiento)}
                            </span>
                        </div>
                        </div>
                    )}
                    </>
                )}
                </div>
                {hasPendingRequest && (
                    <div className="alert alert-warning text-center" role="alert" style={{ marginBottom: "1rem" }}>
                    La última solicitud está en proceso. Por favor, espera a que sea aceptada, rechazada o cancelada.
                    </div>
                )}
            </div>

            <div className="d-flex flex-column flex-md-row  mt-3" style={{ gap: "1rem" }}>
                {showAddWithdrawButtons ? (
             <>
             {/* Saldo actual */}
             <div className="d-flex flex-column flex-md-row  mb-3 gap-2">
                 <div className="box-input-primary">Saldo actual</div>
                 <input
                     type="text"
                     className="form-control flex-grow-1"
                     value={formatCurrency(caja?.SaldoCaja || 0)}
                     readOnly
                 />
             </div>
         
             {/* Monto y botones */}
             <div className="d-flex flex-column flex-md-row mb-3 p-0" style={{ gap: "1rem" }}>
                <div className="d-flex flex-column flex-md-row gap-2 w-100 w-md-auto">
                    <div className="box-input-secondary">Monto</div>
                    <input
                        type="number"
                        className="form-control flex-grow-1"
                        onChange={(e) => handleNewBalanceChange(e, caja.IdCaja)}
                        name="monto"
                        step="any"
                        placeholder="Introducir monto"
                        value={newBalance[caja.IdCaja] || ""}
                        disabled={caja.EstatusCaja === 1}
                    />
                </div>
                            
                {/* Botones: Añadir, Retirar y Anular */}   
                <div className="d-flex flex-column flex-sm-row flex-md-row gap-2 w-100 w-sm-auto" style={{ gap: "1rem" }}>
                    {/* Botón Añadir */}
                    {isLoadingAdd ? (
                        <button type="submit" className="btn btn-blue w-100" disabled>
                            <Spinner type={1} size={15} />
                        </button>
                    ) : (
                        <button
                            className="btn btn-blue w-100"
                            onClick={() => handleTransaction(caja, newBalance[caja.IdCaja], 3)}
                            disabled={caja.EstatusCaja === 1 || !newBalance[caja.IdCaja] || isNaN(Number(newBalance[caja.IdCaja])) || hasPendingRequest}
                        >
                            Añadir
                        </button>
                    )}
            
                    {/* Botón Retirar */}
                    {isLoadingWithdraw ? (
                        <button type="submit" className="btn btn-outline-blue w-100" disabled>
                            <Spinner type={1} size={15} />
                        </button>
                    ) : (
                        <button
                            className="btn btn-outline-blue w-100"
                            onClick={() => handleTransaction(caja, newBalance[caja.IdCaja], 4)}
                            disabled={caja.EstatusCaja === 1 || !newBalance[caja.IdCaja] || isNaN(Number(newBalance[caja.IdCaja]))|| hasPendingRequest}
                        >
                            Retirar
                        </button>
                    )}
            
                    {/* Botón Anular */}
                    {[3].includes(caja.IdTipoMovimiento) && caja.SaldoCaja === caja.UltimoSaldoAgregado && (
                        <>
                            {isLoadingCancel ? (
                                <button type="submit" className="btn btn-warning w-100" disabled>
                                    <Spinner type={1} size={15} />
                                </button>
                            ) : (
                                <button
                                    className="btn btn-warning w-100"
                                    onClick={() => handleTransaction(caja, montoAnulado, 5)}
                                    disabled={caja.EstatusCaja === 1 || !montoAnulado || isNaN(Number(montoAnulado)) || hasPendingRequest}
                                >
                                    Anular
                                </button>
                            )}
                        </>
                    )}
                </div>
            </div>
         </>
                  ) : (
                    <>
                     <div className="d-flex">
                        <div className="box-input-primary">
                            {caja.EstatusCaja === 1 ? "Saldo Anterior" : "Saldo Anterior"}
                        </div>
                        <input
                            type="text"
                            className="form-control "
                            value={formatCurrency(
                                caja?.EstatusCaja === 1 
                                  ? caja?.UltimoSaldoApertura ?? 0 
                                  : caja?.UltimoSaldoCierre ?? 0
                              )}
                              
                            readOnly
                         />
                    </div>
                        <div className="d-flex flex-row">
                            <div className="box-input-secondary">
                                Saldo Actual
                            </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formatCurrency(caja?.SaldoCaja || 0)}
                                    disabled
                                />
                           
                            <div className="d-flex align-items-center ml-3" style={{ gap: 20 }}>
                                {caja.EstatusCaja === 1 ? (
                                    <button
                                        className="btn btn-blue"
                                        onClick={() => handleOpenCloseCash(2, caja)}
                                        disabled={!caja || isLoading[caja.IdCaja]}
                                        style={{ width: '130px', height: 'auto' }}
                                    >
                                     <span>
                                        {isLoading[caja.IdCaja] ? (
                                            <Spinner type={1} style={{ width: '20px', height: '20px' }} />  
                                        ) : (
                                            <>
                                       <FaLock /> Confirmar
                                            </>
                                        )}
                                    </span>
                                        
                                    </button>
                                ) : (
                                    <button
                                        className="btn btn-blue"
                                        onClick={() => handleOpenCloseCash(1, caja)}
                                        disabled={!caja || isLoading[caja.IdCaja]}
                                        style={{ width: '120px', height: 'auto' }}
                                    >
                                        {isLoading[caja.IdCaja] ? (
                                            <Spinner type={1} style={{ width: '20px', height: '20px' }} />  
                                        ) : (
                                            <>
                                       <FaLock /> Confirmar
                                            </>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default CajaCard;